
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AgencyAsFreelancerPageResource,
  ValidationError,
} from '../models';
import {
    AgencyAsFreelancerPageResourceFromJSON,
    AgencyAsFreelancerPageResourceToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface ListAgenciesAsFreelancersRequest {
    searchText?: string;
    nafCode?: string;
    idcc?: string;
    companySize?: ListAgenciesAsFreelancersCompanySizeEnum;
    sortBy?: ListAgenciesAsFreelancersSortByEnum;
    sortDir?: ListAgenciesAsFreelancersSortDirEnum;
    page?: number;
    size?: number;
}

export interface MigrateAgencyToSubcontractorRequest {
    companyId: string;
}

/**
 * 
 */
export class AgencyFreelancerAdminApi extends runtime.BaseAPI {

    /**
     * Returns a paginated list of freelancer accounts that match agency criteria (NAF codes 62.01Z, 62.02A, 62.02B), enriched with IDCC, company size from legal_information, and BigQuery activity data (nb_projects last 12m, last project date, GSV last 12m). Filters apply only to database columns, not BQ data. 
     * List FREELANCE identities matching agency criteria (admin endpoint)
          */
    async listAgenciesAsFreelancersRaw(requestParameters: ListAgenciesAsFreelancersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AgencyAsFreelancerPageResource>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['nafCode'] != null) {
            queryParameters['nafCode'] = requestParameters['nafCode'];
        }

        if (requestParameters['idcc'] != null) {
            queryParameters['idcc'] = requestParameters['idcc'];
        }

        if (requestParameters['companySize'] != null) {
            queryParameters['companySize'] = requestParameters['companySize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDir'] != null) {
            queryParameters['sortDir'] = requestParameters['sortDir'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AgencyAsFreelancerPageResource>({
            path: `/compliance/api/admin/agencies-as-freelancers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AgencyAsFreelancerPageResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns a paginated list of freelancer accounts that match agency criteria (NAF codes 62.01Z, 62.02A, 62.02B), enriched with IDCC, company size from legal_information, and BigQuery activity data (nb_projects last 12m, last project date, GSV last 12m). Filters apply only to database columns, not BQ data. 
     * List FREELANCE identities matching agency criteria (admin endpoint)
          */
    async listAgenciesAsFreelancers(requestParameters: ListAgenciesAsFreelancersRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AgencyAsFreelancerPageResource> {
        const response = await this.listAgenciesAsFreelancersRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Switches the identity type of the given freelancer company from FREELANCE to SUBCONTRACTOR. The action is logged and auditable. Safe to call: no credit note risk on this identity type switch. 
     * Migrate a FREELANCE identity to SUBCONTRACTOR (admin endpoint)
          */
    async migrateAgencyToSubcontractorRaw(requestParameters: MigrateAgencyToSubcontractorRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling migrateAgencyToSubcontractor().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/compliance/api/admin/agencies-as-freelancers/{companyId}/migrate`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Switches the identity type of the given freelancer company from FREELANCE to SUBCONTRACTOR. The action is logged and auditable. Safe to call: no credit note risk on this identity type switch. 
     * Migrate a FREELANCE identity to SUBCONTRACTOR (admin endpoint)
          */
    async migrateAgencyToSubcontractor(requestParameters: MigrateAgencyToSubcontractorRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.migrateAgencyToSubcontractorRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ListAgenciesAsFreelancersCompanySizeEnum = {
    Individual: 'INDIVIDUAL',
    Between2And10: 'BETWEEN_2_AND_10',
    Between11And49: 'BETWEEN_11_AND_49',
    Between50And249: 'BETWEEN_50_AND_249',
    Between250And999: 'BETWEEN_250_AND_999',
    Between1000And4999: 'BETWEEN_1000_AND_4999',
    MoreThan5000: 'MORE_THAN_5000',
    Unknown: 'UNKNOWN'
} as const;
export type ListAgenciesAsFreelancersCompanySizeEnum = typeof ListAgenciesAsFreelancersCompanySizeEnum[keyof typeof ListAgenciesAsFreelancersCompanySizeEnum];
/**
 * @export
 */
export const ListAgenciesAsFreelancersSortByEnum = {
    CompanyName: 'companyName',
    NafCode: 'nafCode',
    CompanySize: 'companySize',
    NbProjectsLast12m: 'nbProjectsLast12m',
    GsvLast12m: 'gsvLast12m',
    DomainName: 'domainName'
} as const;
export type ListAgenciesAsFreelancersSortByEnum = typeof ListAgenciesAsFreelancersSortByEnum[keyof typeof ListAgenciesAsFreelancersSortByEnum];
/**
 * @export
 */
export const ListAgenciesAsFreelancersSortDirEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListAgenciesAsFreelancersSortDirEnum = typeof ListAgenciesAsFreelancersSortDirEnum[keyof typeof ListAgenciesAsFreelancersSortDirEnum];
